"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ChapterIntro_1 = __importDefault(require("./ChapterIntro"));
const ChapterConcern_1 = __importDefault(require("./ChapterConcern"));
const ChapterSpread_1 = __importDefault(require("./ChapterSpread"));
const ChapterFace_1 = __importDefault(require("./ChapterFace"));
const ChapterHole_1 = __importDefault(require("./ChapterHole"));
const ChapterApproach_1 = __importDefault(require("./ChapterApproach"));
const ChapterInvade_1 = __importDefault(require("./ChapterInvade"));
const ChapterDown_1 = __importDefault(require("./ChapterDown"));
const ChapterStairs_1 = __importDefault(require("./ChapterStairs"));
const ChapterWave_1 = __importDefault(require("./ChapterWave"));
const ChapterShallowWater_1 = __importDefault(require("./ChapterShallowWater"));
const ChapterSink_1 = __importDefault(require("./ChapterSink"));
const ChapterConfetti_1 = __importDefault(require("./ChapterConfetti"));
const ChapterFreeze_1 = __importDefault(require("./ChapterFreeze"));
const ChapterWalking_1 = __importDefault(require("./ChapterWalking"));
const ChapterDirection_1 = __importDefault(require("./ChapterDirection"));
const ChapterDespair_1 = __importDefault(require("./ChapterDespair"));
const ChapterDoor_1 = __importDefault(require("./ChapterDoor"));
const ChapterRun_1 = __importDefault(require("./ChapterRun"));
const ChapterTurn_1 = __importDefault(require("./ChapterTurn"));
const ChapterSmall_1 = __importDefault(require("./ChapterSmall"));
const ChapterMeet_1 = __importDefault(require("./ChapterMeet"));
const ChapterHug_1 = __importDefault(require("./ChapterHug"));
const ChapterEnd_1 = __importDefault(require("./ChapterEnd"));
class ChapterManager {
    constructor(stage, signals) {
        this.stage = stage;
        this.signals = signals;
        this.chapters = [];
        this.idx = 0;
    }
    init(stage) {
        this.signals.nextChapter.add(this.next.bind(this));
        this.chapters = [
            new ChapterIntro_1.default(stage, '', 'intro', this.signals),
            new ChapterConcern_1.default(stage, [
                'There was something small and dark.',
                "At first I couldn't even know if It was there.",
            ], 'concern'),
            new ChapterSpread_1.default(stage, 'But it was always by my side', 'spread'),
            new ChapterFace_1.default(stage, 'When I first encountered it', 'face'),
            new ChapterHole_1.default(stage, "I couldn't figure out what to do.", 'hole'),
            new ChapterApproach_1.default(stage, 'But it crept slowly on me\nand when I got one step closer', 'approach'),
            new ChapterInvade_1.default(stage, 'It swallowed me up', 'invade'),
            new ChapterDown_1.default(stage, 'I went down endlessly', 'down'),
            new ChapterStairs_1.default(stage, 'deep into it.', 'stairs'),
            new ChapterWave_1.default(stage, 'I was swept away', 'wave'),
            new ChapterShallowWater_1.default(stage, "I didn't know if it was day or night", 'shallowwater'),
            new ChapterSink_1.default(stage, 'As if I was submerged', 'sink'),
            new ChapterConfetti_1.default(stage, "I couldn't feel anything", 'confetti'),
            new ChapterFreeze_1.default(stage, 'I couldn’t lift even one finger', 'freeze'),
            new ChapterWalking_1.default(stage, 'I kept going without destination', 'walking'),
            new ChapterDirection_1.default(stage, "and yet I couldn't still find the direction", 'direction'),
            new ChapterDespair_1.default(stage, 'When I gave up getting out', 'despair'),
            new ChapterDoor_1.default(stage, 'Someone opened the door', 'door'),
            new ChapterRun_1.default(stage, 'While Running away like that', 'run'),
            new ChapterTurn_1.default(stage, 'I suddenly looked back\nIt was there', 'turn'),
            new ChapterSmall_1.default(stage, 'A small, black dog', 'small'),
            new ChapterMeet_1.default(stage, 'It followed me', 'meet'),
            new ChapterHug_1.default(stage, 'And I hugged the black dog in my arms', 'hug'),
            new ChapterEnd_1.default(stage, '', 'end'),
        ];
        this.chapters.forEach(chapter => {
            chapter.addEventListener('text-show', this._onShowText.bind(this));
            chapter.addEventListener('text-hide', this._onHideText.bind(this));
            chapter.addEventListener('done', this._onDone.bind(this));
            chapter.addEventListener('text-black', this._onTextBlack.bind(this));
            chapter.addEventListener('text-white', this._onTextWhite.bind(this));
        });
    }
    start(key) {
        this.idx = this._getChapterIdx(key);
        this.chapters[this.idx].start();
        if (this.idx !== 0) {
            this.signals.showHeader.dispatch();
        }
    }
    next() {
        const currChapter = this._getCurrChapter();
        this.signals.hideText.dispatch();
        currChapter.stop(() => {
            this.idx += 1;
            const curr = this._getCurrChapter();
            curr.start();
            if (curr.key === 'spread') {
                this.signals.hideIndicatorText.dispatch();
            }
            if (curr.key === 'end') {
                this.end();
            }
        });
    }
    end() {
        this.signals.hideAbout.dispatch();
    }
    update(time) {
        this.chapters[this.idx] && this.chapters[this.idx].update(time);
    }
    _onDone(event) {
        var _a, _b, _c;
        this.signals.readyNextChapter.dispatch((_a = event.data) === null || _a === void 0 ? void 0 : _a.position, (_b = event.data) === null || _b === void 0 ? void 0 : _b.offset, (_c = event.data) === null || _c === void 0 ? void 0 : _c.color);
    }
    _onShowText(event) {
        this.signals.showText.dispatch(event.text, event.color);
    }
    _onHideText() {
        this.signals.hideText.dispatch();
    }
    _onTextWhite() {
        this.signals.textWhite.dispatch();
    }
    _onTextBlack() {
        this.signals.textBlack.dispatch();
    }
    _getChapterIdx(key) {
        for (let i = 0; i < this.chapters.length; i++) {
            if (this.chapters[i].key === key)
                return i;
        }
        return 0;
    }
    _getCurrChapter() {
        return this.chapters[this.idx];
    }
}
exports.default = ChapterManager;
